import React from "react";
import { getViewInfo } from "src/common/attrView";
import { ImageSize } from "src/components/PlmUploader/imgSrc";
import { MakeLabelParams } from "../../types/MakeLabelParams";
import { getAttrLabelTreeData } from "../../utils/getAttrLabelTreeData";
import { ImgList } from "./ImgList/ImgList";

export const makeImageListLabel = (
  params: MakeLabelParams,
  imgSize?: ImageSize,
) => {
  const { attribute, labelTreeData } = params;

  const values = getAttrLabelTreeData(attribute, labelTreeData)?.labels ?? [];
  const maxHeight = getViewInfo(attribute.viewType)?.styles?.maxHeight;

  return <ImgList values={values} maxHeight={maxHeight} imgSize={imgSize} />;
};
